import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn, createRenameTransformer } from '../common/utils';
import { CourseSchema, DBCourseSchema } from './schemas';

export const CourseCodecConfig: TransformerConfig<typeof CourseSchema, typeof DBCourseSchema> = {
  name: 'Course',
  clientSchema: CourseSchema,
  dbSchema: DBCourseSchema,
  transformers: [
    createRenameTransformer<typeof CourseSchema, typeof DBCourseSchema>('id', 'courseId'),
  ],
};

export const encodeCourseToDb = createEncodeToDbFn(CourseCodecConfig);
export const decodeCourseFromDb = createDecodeFromDbFn(CourseCodecConfig);
